import { render, staticRenderFns } from "./referral-balance.vue?vue&type=template&id=3b97d668&scoped=true&"
import script from "./referral-balance.vue?vue&type=script&lang=ts&"
export * from "./referral-balance.vue?vue&type=script&lang=ts&"
import style0 from "./referral-balance.vue?vue&type=style&index=0&id=3b97d668&lang=scss&scoped=true&"
import style1 from "./referral-balance.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b97d668",
  null
  
)

export default component.exports